import axiosInstance from "../axiosInstance";

export const startCrossAppImpersonation = (employeeUuid: string) =>
  axiosInstance.post(`/api/private/impersonation/start/${employeeUuid}`);

export const stopCrossAppImpersonation = () =>
  axiosInstance.post("/api/private/impersonation/stop");
